<template>
  <div class="c-providerlist">
    <v-dialog
      v-model="dialog"
      max-width="600px"
      eager
    >
      <provider-edit
        ref="editor"
        v-on:dismissed="dialog = false"
        v-on:saved="dialog = false"
      ></provider-edit>
    </v-dialog>

    <v-row>
      <v-col>
        <div class="page-title">Liste des fournisseurs</div>
        <v-alert :value="!!error" type="error">
          {{ error }}
        </v-alert>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="auto">
        <v-row>
          <period-selector
          ></period-selector>
        </v-row>

        <v-row>
          <v-btn
            color="primary"
            class="mb-2 mx-1"
            @click.stop="addItem"
          >
            Ajouter
          </v-btn>
          <v-btn
            color="primary"
            class="mb-2 mx-1"
            @click="exportProviders"
          >
            Exporter tous
            <v-icon right>save_alt</v-icon>
          </v-btn>
        </v-row>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="auto">
        <v-data-table
          :headers="headers"
          :items="items"
          :loading="loading"
          item-key="producer_id"
          single-expand
          disable-pagination
          hide-default-footer
          class="elevation-1 transparent"
        >
          <template v-slot:item="{ item, expand, isExpanded }">
            <tr class="c-providerlist__tablerow" @click.stop="expand(!isExpanded)">
              <td>{{ item.name }}</td>
              <td>{{ item.address ? item.address.country:"" }}</td>
              <td>{{ item.contact_name }}</td>

              <td class="justify-center layout px-0">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn icon class="mx-0" v-on="on" @click.stop="exportOverviewWine(item)">
                      <v-icon color="white">save_alt</v-icon>
                    </v-btn>
                  </template>
                  <span>Exporter Overview Vin</span>
                </v-tooltip>
                <v-tooltip bottom v-if="hasRole('admin')">
                  <template v-slot:activator="{ on }">
                    <v-btn icon class="mx-0" v-on="on" @click.stop="editItem(item)">
                      <v-icon color="teal">edit</v-icon>
                    </v-btn>
                  </template>
                  <span>Editer</span>
                </v-tooltip>
                <v-tooltip bottom v-if="hasRole('admin')">
                  <template v-slot:activator="{ on }">
                    <v-btn icon class="mx-0" v-on="on" @click.stop="deleteItem(item)">
                      <v-icon color="pink">delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Supprimer</span>
                </v-tooltip>
              </td>
            </tr>
          </template>

          <template v-slot:expanded-item="{ item }">
            <td :colspan="headers.length">
              <v-card flat class="grey darken-2">
                <v-card-title primary-title>
                  <h4 class="headline mb-0">{{ item.name }}</h4>
                </v-card-title>
                <v-card-text>
                  <div>
                    <span>{{ `${item.address ? item.address.address:""}, ${item.address ? item.address.zipCode:""} ${item.address ? item.address.city:""} -- ${item.address ? item.address.country:""}` }}</span><br/>
                    <span>Contact : {{ item.contact_name }}</span><br/>
                    <span>N° tél : {{ item.phone_number }}</span><br/>
                    <span>Mail : {{ item.email }}</span><br/>
                  </div>
                </v-card-text>
              </v-card>
            </td>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import ExportAPI from '@/api/export';

import PeriodSelector from '@/components/PeriodSelector';
import ProviderEdit from '@/components/ProviderEdit';

import CSVExport from '@/mixins/CSVExport';
import ErrorManagement from '@/mixins/ErrorManagement';
import PeriodListener from '@/mixins/PeriodListener';
import RoleFiltering from '@/mixins/RoleFiltering';

import { PRODUCER_DELETE, PRODUCER_LIST } from '@/store/actions/producer';


export default {
  name: 'ProviderList',

  mixins: [
    CSVExport,
    ErrorManagement,
    PeriodListener,
    RoleFiltering
  ],

  components: {
    PeriodSelector,
    ProviderEdit
  },

  data: () => ({
    loading: false,
    headers: [
      { text: 'Nom du fournisseur', value: 'name' },
      { text: 'Pays', value: 'country' },
      { text: 'Contact', value: 'contact' },
      { text: 'Actions', value: 'actions', sortable: false }
    ],

    dialog: false
  }),

  computed: {
    ...mapState({
      defaultItem: state => state.producer.defaultItem,
      items: state => state.producer.producers
    })
  },

  mounted () {
    this.loading = true;
    this.$store.dispatch(PRODUCER_LIST)
      .catch((err) => {
        this.setError(err);
      })
      .finally(() => {
        this.loading = false;
      });
  },

  methods: {
    addItem () {
      this.$refs.editor.edit(null);
      this.dialog = true;
    },
    editItem (item) {
      this.$refs.editor.edit(item);
      this.dialog = true;
    },
    deleteItem (item) {
      if (!confirm('Etes-vous sûr de vouloir supprimer ce fournisseur ?')) {
        return;
      }

      this.$store.dispatch(PRODUCER_DELETE, item.producer_id)
        .catch((err) => {
          this.setError(err);
        });
    },

    exportProviders () {
      this.saveCSV(ExportAPI.getProducers(), 'export_providers');
    },
    exportOverviewWine (item) {
      this.saveCSV(ExportAPI.getOverviewWine(
        this.period,
        this.period_from,
        this.period_to,
        null,
        item.producer_id
      ), 'export_overview_wine');
    }
  }
};
</script>

<style lang="scss" scoped>
.c-providerlist {
  &__tablerow {
    cursor: pointer;
  }
}
</style>
